import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { RichText } from '@atlassiansox/bxp-content-framework';
import { blockquoteCSS, getOrderedListCSS, getTextSizeCSS } from '../../styles';
export default function UiTextBlock({ model }) {
    const { text, textSize, orderedListAppearance } = model.content;
    return (_jsx(TextBlock, Object.assign({ textSize: textSize, orderedListAppearance: orderedListAppearance }, { children: _jsx(RichText, { document: text }, void 0) }), void 0));
}
export const TextBlock = styled.div `
  ${({ textSize }) => getTextSizeCSS(textSize)}
  ${({ orderedListAppearance }) => getOrderedListCSS(orderedListAppearance)}
  ${blockquoteCSS}
`;
//# sourceMappingURL=UiTextBlock.js.map